import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { LangFlag, TranslationService } from '../../../../services/translation.service';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ParticleCalibration } from '../../../../model/particleCalibration';
import { InternalEquipment } from '../../../../model/internalEquipment';
import { ParticleCalibrationService } from '../../../../services/particleCalibration.service';
import { InternalEquipmentService } from '../../../../services/internalEquipment.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { CalibrationParticlesUtils } from '../../../../utils/calibrationParticlesUtils';
import saveAs from 'file-saver';

export interface DialogDataManaulSignCalibration {
  calibration: ParticleCalibration;
  equipment: InternalEquipment;
}
@Component({
  selector: 'app-particles-edit-manual-sign-report',
  templateUrl: './particles-edit-manual-sign-report.component.html',
  styleUrl: './particles-edit-manual-sign-report.component.scss',
  standalone: false
})
export class ParticlesEditManualSignReportComponent implements OnInit, OnDestroy {

  langs: LangFlag[];

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ParticlesEditManualSignReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataManaulSignCalibration,
    private calibrationParticleService: ParticleCalibrationService,
    private internalEquipmentService: InternalEquipmentService,
    private translate: TranslateService,
    private translationService: TranslationService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.langs = this.translationService.configuredLangs;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  downloadDocument(): void {
    this.spinnerService.show();

    this.calibrationParticleService.downloadPdf(this.data.calibration.id).pipe(takeUntil(this.destroy$))
      .subscribe((res: File) => {
        this.downloadFile(this.data.calibration, res);
      }, () => {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.generic') as string);
        this.spinnerService.hide();
      });
  }

  onOkClick(event): void {
    const file = event.target.files[0] as File;

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {

      if (token != null) {
        this.spinnerService.show();

        this.calibrationParticleService.manualSign(this.data.calibration, file, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.sign.ok') as string);

          this.spinnerService.hide();

          this.dialogRef.close(token);
        }, () => {
          this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.sign.error') as string);

          this.spinnerService.hide();
        });
      } else {
        this.spinnerService.hide();
      }
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }

  private downloadFile(calibration: ParticleCalibration, file: File) {
    this.spinnerService.show();

    this.internalEquipmentService.findOne(calibration.idEquipment).pipe(takeUntil(this.destroy$))
      .subscribe((equipment: InternalEquipment) => {
        const name = CalibrationParticlesUtils.getNameForCalibration(this.data.calibration, equipment, this.translate);
        saveAs(file, name);
        this.spinnerService.hide();
      }, () => {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.generic') as string);
        this.spinnerService.hide();
      });
  }
}
